import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { useState } from "react";
import FeedbackThanks from "../../pages/relaxation/FeedbackThanks";
import Feedback from "../../pages/relaxation/Feedback";

function Relaxation9() {
  const [showFeedback, setShowFeedback] = useState(false);
  const [showFeedbackThanks, setShowFeedbackThanks] = useState(false);

  return (
    <div className="relative ">
      <FeedbackThanks
        showFeedback={showFeedback}
        setShowFeedback={setShowFeedback}
        showFeedbackThanks={showFeedbackThanks}
        setShowFeedbackThanks={setShowFeedbackThanks}
      />
      <Feedback
        showFeedback={showFeedback}
        setShowFeedback={setShowFeedback}
        showFeedbackThanks={showFeedbackThanks}
        setShowFeedbackThanks={setShowFeedbackThanks}
      />
      <div className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md -mt-3">
        <div id="relaxationTab" className="relative min-h-[100vh]">
          <section className="flex mt-[30px] mb-[40px] text-[#2A5801]">
            {/* Relaxation */}
            <div id="relaxation" className=" ">
              <div className="  inline-block mx-[10px] px-[5px] mt-[10px]">
                <h2 className="text-xl font-bold">RELAXATION</h2>
              </div>
              <p className="mx-[18px] mt-[5px] text-[#2A5801]">
                5 MINUTE BREATHING EXERCISE
              </p>
              <h1 className="mt-[70px] text-center mx-[410px] text-xl font-bold text-[#2A5801]">
                EXERCISE COMPLETED!
              </h1>
              <h1 className="text-center mt-[10px] text-xl font-bold text-[#2A5801]">
                CONGRATULATIONS
              </h1>
              <div className="flex mt-[40px] justify-center items-center">
                <img
                  src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779833/Vector-1_zess1v.png"
                  alt=""
                />
                <img
                  className="ml-[50px]"
                  src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779833/Vector_v4nbx3.png"
                  alt=""
                />
              </div>
              <div className="flex justify-center items-center mt-[50px]">
                <div className="flex">
                  <button className="bg-[#295700] text-white rounded-[5px] px-[10px] py-[5px]">
                    Do Another Exercise
                  </button>
                  <button
                    onClick={() => setShowFeedback(!showFeedback)}
                    className="bg-[#295700] text-white rounded-[5px] ml-[20px] px-[10px] py-[5px]"
                  >
                    Feedback
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Relaxation9;
